import MenuItem, { MenuItemProps } from './MenuItem';

export type { MenuItemProps };
export default MenuItem;
